// extracted by mini-css-extract-plugin
export default {"regionDropdown":"BusinessEnterpriseNetworkPage-module__regionDropdown__OU80z"};